export const getStyled = (theme, logo) => ({
  root: {
    width: '100vw',
    height: '100vh',
    background:
      'radial-gradient(circle,rgba(92, 108, 191, 1) 0%, rgba(24, 28, 53, 1) 100%)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: '#ffffff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '55px 30px',
    borderRadius: '12.5px',
    height: '500px',
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
    position: 'relative',
    minHeight: 'max-content',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    top: '-30%',
  },
  logoImg: {
    width: '100%',
    maxWidth: '350px',
    height: 'auto',
    maxHeight: '120px',
    margin: '0 auto',
    borderRadius: '100px',
    border: '5px solid #FFFFFF',
    boxShadow: '0px 20px 30px -10px; rgb(38, 57, 77)',
    content: `url(${logo})`,
    display: 'flex',
    position: 'relative',
    top: '-100%',
  },
  iconButton: {
    position: 'absolute',
    top: 10,
    right: 10,
    color: 'black',
  },
  customInput: {
    color: `#192734 !important`,

    '& .MuiInputBase-input': {
      color: `#192734 !important`,
      WebkitTextFillColor: `#192734 !important`,
    },

    '& .MuiInputLabel-root': {
      color: `#192734 !important`,
      '&.Mui-focused': {
        color: `#192734 !important`,
      },
      '&.MuiInputLabel-shrink': {
        color: `#192734 !important`,
      },
    },

    '& .MuiInputLabelRoot.Mui-focused': {
      color: `#192734 !important`,
    },

    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: `#192734 !important`,
        borderWidth: '2px !important',
      },
      '&:hover fieldset': {
        borderColor: `#192734 !important`,
      },
      '&.Mui-focused fieldset': {
        borderColor: `#192734 !important`,
      },
    },

    '& .MuiIconButton-root': {
      color: `#192734 !important`,
    },

    '& .MuiInputBase-root': {
      color: `#192734 !important`,
    },

    '& .MuiSelect-select': {
      color: theme.custom.colors.text,
      backgroundColor: theme.custom.colors.defaultBackground,
      borderColor: theme.custom.colors.text,
    },

    '& .MuiSelect-icon': {
      color: theme.custom.colors.text,
      WebkitTextFillColor: `'#192734' !important`,
    },

    '& .MuiMenu-paper': {
      backgroundColor: theme.custom.colors.defaultBackground,
    },

    '& .MuiMenuItem-root': {
      color: theme.custom.colors.text,
      '&:hover': {
        backgroundColor: theme.custom.colors.defaultBackground,
      },
      '&.Mui-selected': {
        backgroundColor: theme.custom.colors.defaultBackground,
      },
    },

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: `'#192734' !important`,
    },

    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: `'#192734' !important`,
    },

    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: `'#192734' !important`,
    },

    '& .MuiPaper-root': {
      backgroundColor: theme.custom.colors.defaultBackground,
      color: theme.custom.colors.text,
      WebkitTextFillColor: `'#192734' !important`,
    },

    '& .MuiDialogActions-root .MuiButton-root': {
      WebkitTextFillColor: `'#192734' !important`,
      color: theme.custom.colors.text,
    },

    '& .Mui-disabled': {
      color: `grey !important`,
      WebkitTextFillColor: `grey !important`,
    },
    '& .MuiOutlinedInput-root.Mui-disabled': {
      '& fieldset': {
        borderColor: `grey !important`,
        opacity: 0.5,
      },
    },
    '& .MuiInputLabel-root.Mui-disabled': {
      color: `grey !important`,
      WebkitTextFillColor: `grey !important`,
      opacity: 0.5,
    },
    '& .MuiIconButton-root.Mui-disabled': {
      color: `grey !important`,
      WebkitTextFillColor: `grey !important`,
      opacity: 0.5,
    },
  },
  customStyle: {
    borderRadius: '5px',
    boxShadow: 'rgba(0, 0, 0, 0.5) 1.95px 1.95px 2.6px',
    backgroundColor: '#fd7135',
    color: 'white',
    fontSize: '14px',
    marginBottom: '10px',
    padding: 15,
    '&:hover': {
      backgroundColor: '#fd7135',
      opacity: '0.8',
    },
  },
  customStyle2: {
    borderRadius: '5px',
    boxShadow: 'rgba(0, 0, 0, 0.5) 1.95px 1.95px 2.6px',
    backgroundColor: '#181c35',
    color: 'white',
    fontSize: '14px',
    marginBottom: '10px',
    padding: 15,
    '&:hover': {
      backgroundColor: '#181c35',
      opacity: '0.8',
    },
  },
  customLink: {
    color: '#181c35',

    '&:hover': {
      textDecoration: 'underline',
    },
  },
  customCheck: {
    color: '#181c35 !important',

    '&:hover': {
      backgroundColor: 'rgba(24,28,53,0.1)',
    },

    '&.MuiChecked': {
      color: '#181c35 !important',
    },
  },
});
